export var StatisticSurveyStatusType;
(function (StatisticSurveyStatusType) {
    StatisticSurveyStatusType["Archived"] = "Archived";
    StatisticSurveyStatusType["Planned"] = "Planned";
    StatisticSurveyStatusType["InProgress"] = "InProgress";
    StatisticSurveyStatusType["Finished"] = "Finished";
})(StatisticSurveyStatusType || (StatisticSurveyStatusType = {}));
export var StatisticSurveyType;
(function (StatisticSurveyType) {
    StatisticSurveyType["EmployeeNetPromoterScore"] = "EmployeeNetPromoterScore";
    StatisticSurveyType["Quiz"] = "Quiz";
    StatisticSurveyType["Custom"] = "Custom";
    StatisticSurveyType["NewsFeedSurvey"] = "NewsFeedSurvey";
    StatisticSurveyType["EmployeeAssessment"] = "EmployeeAssessment";
    StatisticSurveyType["Testing"] = "Testing";
})(StatisticSurveyType || (StatisticSurveyType = {}));
